module.exports = __webpack_public_path__ + "static/media/bill-preview.46574296.png";